import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('skyline', {
  cherry: 'champagne',
  lemon: 'cocktail',
  orange: 'city_lights',
  bell: 'elevator_bell',
  star: 'penthouse_wild',
  seven: 'skyscraper',
  gem: 'skyline_diamond',
  scatter: 'vip_pass_scatter',
  money: 'penthouse_vault',
});

/** Skyline — GENERATED by scaffoldSlot from
 *  content/slots/skyline.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const SKYLINE_THEME: Theme = {
  id: 'skyline',
  name: 'Skyline',
  palette: {
    accent: 0xc89030,
    secondary: 0xe8c060,
    warm: 0xf2d27a,
    frameFill: 0x1a1426,
    bgGradientTop: 0x33264a,
    bgGradientBottom: 0x100a18,
    dimOverlay: 0x07050c,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Sparkling Cider', glyph: '🍏', tint: 0xe0c060, weight: 5, textureAlias: 'skyline:cherry',
        winVideoAlias: 'skyline:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Mocktail', glyph: '🍹', tint: 0xe04080, weight: 5, textureAlias: 'skyline:lemon',
        winVideoAlias: 'skyline:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'City Lights', glyph: '🏙️', tint: 0xc06040, weight: 4, textureAlias: 'skyline:orange',
        winVideoAlias: 'skyline:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Penthouse Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'skyline:bell',
        winVideoAlias: 'skyline:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Skyline', glyph: '🌆', tint: 0xc89030, weight: 2, textureAlias: 'skyline:star',
        winVideoAlias: 'skyline:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'High Rise', glyph: '🏢', tint: 0x6040a0, weight: 2, textureAlias: 'skyline:seven',
        winVideoAlias: 'skyline:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Diamond', glyph: '💎', tint: 0xe0f0f8, weight: 2.5, textureAlias: 'skyline:gem',
        winVideoAlias: 'skyline:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'VIP Pass', glyph: '🎟️', tint: 0xf0c040, weight: 0.5, textureAlias: 'skyline:scatter',
        winVideoAlias: 'skyline:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Penthouse Vault', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'skyline:money',
        winVideoAlias: 'skyline:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xc89030, multiplier: 1, weight: 5 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xc89030, multiplier: 1, weight: 5 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xe8c060, multiplier: 3, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x1-c', kind: 'multiplier', label: '×1', tint: 0xc89030, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x2-c', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xe8c060, multiplier: 3, weight: 3 },
      { id: 'x1-d', kind: 'multiplier', label: '×1', tint: 0xc89030, multiplier: 1, weight: 4 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xf2d27a, multiplier: 10, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'skyline:bg', path: 'environment/skyline.png' },
      columnBackground: { alias: 'skyline:column_bg', path: 'reel/skyline_column_bg.png' },
      border: { alias: 'skyline:border', path: 'brand/border_neon.png' },
    },
  },
};
